import axios from 'axios'
import Vue from 'vue'
import router from '../src/router/index'
// import qs, { stringify } from 'qs'
// import merge from 'lodash/merge'

const http = axios.create({
  timeout: 1000 * 60 * 2,
  withCredentials: true, // withCredentials: false,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
}) // 请求拦截器

http.interceptors.request.use((config) => {
  let token = localStorage.getItem('token')

  // console.log("token===="+token)
  if (token) {
    config.headers['token'] = token // 请求头带上token
  } else {
    let loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
    config.headers['token'] = loginInfo ? loginInfo.token : null // 请求头带上token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
http.interceptors.response.use((response) => {
  // 状态码填写
  if (response.status === 200) {
    // console.log(response.data)
    if (!response.data.success) {
      // if(response.data.msg.indexOf('智能短信') != -1) {
      //   Vue.prototype.globalMethod.showInfo(response.data.msg)
      // } else {
      //   Vue.prototype.globalMethod.showError(response.data.msg)
      // }
      Vue.prototype.globalMethod.showError(response.data.msg)
      return Promise.resolve(response.data)
    } else {
      return Promise.resolve(response.data)
    }
  } else {
    return Promise.reject(response.data)
  }
}, (error) => {
  let returnResponse = {}
  if (error.response) {
    switch (error.response.status) {
      case 401:
        let token = localStorage.getItem('token') || localStorage.getItem('userMessage')
        if (token) {
          localStorage.removeItem('userMessage')
          localStorage.removeItem('token')
          Vue.prototype.globalMethod.showError('账号异地登陆，请重新登陆')
          router.replace({
            name: 'login',
          })
        } else {
          Vue.prototype.globalMethod.showError('外部登录异常')
          router.replace({
            name: 'err-page',
          })
        }
        break
      case 504:
        Vue.prototype.globalMethod.showError('网关错误')
        break
      case 404:
        Vue.prototype.globalMethod.showError('无对应接口')
        break
      case 403:
        Vue.prototype.globalMethod.showError('权限不足')
        router.replace({
          name: 'login',
        })
        break
      default:
      // Vue.prototype.globalMethod.showError('接口异常')
    }
    returnResponse = error.response
  } else {
    // Vue.prototype.globalMethod.destroyShow()
    // Vue.prototype.globalMethod.showError('接口异常:' + error.substring())
  }
  return Promise.reject(returnResponse) // 返回接口返回的错误信息
})
export default http



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = nVDU
// module chunks = 6